import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  RetrieveAuthorizationVerbiageRequestV1,
  RetrieveAuthorizationVerbiageResponseV1,
} from '../models';
import { catchError, Observable, of } from 'rxjs';
import { PaymentAuthorizationVerbiageServiceFactory } from '../factories';

@Injectable({
  providedIn: 'root',
})
export class SurchargeAuthVerbiageHelperService {
  constructor(
    private paymentAuthorizationServiceFactory: PaymentAuthorizationVerbiageServiceFactory,
    private translationService: TranslateService,
  ) {}

  retrieveSurchargeVerbiageOrDefault(
    tenantId: string,
    request: RetrieveAuthorizationVerbiageRequestV1,
    acceptACH: boolean,
  ): Observable<RetrieveAuthorizationVerbiageResponseV1> {
    return this.paymentAuthorizationServiceFactory
      .create()
      .retrieveAuthorizationVerbiageV1(tenantId, request)
      .pipe(
        catchError(() => {
          const authorizationTextKey = acceptACH
            ? 'ARC_PAYMENT_SURCHARGE_DEFAULT_VERBIAGE_WITH_ACH'
            : 'ARC_PAYMENT_SURCHARGE_DEFAULT_VERBIAGE';
          const response: RetrieveAuthorizationVerbiageResponseV1 = {
            agreementText: this.translationService.instant(
              'ARC_PAYMENT_SURCHARGE_DEFAULT_VERBIAGE_AGREEMENT_TEXT',
            ) as string,
            authorizationText: this.translationService.instant(
              authorizationTextKey,
            ) as string,
            language: 'en',
            errors: null,
          };

          return of(response);
        }),
      );
  }
}
